import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";

export default class LoadingScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;
    }

    initialize() {
        super.initialize();

        this.preventClickThrough();

        this._baseLoadingText = this._languagePack.getText(`loadingScreen.body`);
        this._target.loadingTextField.text = this._baseLoadingText;

        const loadingDotIntervalMs = 500;
        createjs.Tween.get(this._target.loadingTextField, { loop: -1, })
            .to({
                text: `${this._baseLoadingText}`
            }, 1)
            .wait(loadingDotIntervalMs)
            .to({
                text: `${this._baseLoadingText}.`
            }, 1)
            .wait(loadingDotIntervalMs)
            .to({
                text: `${this._baseLoadingText}..`
            }, 1)
            .wait(loadingDotIntervalMs)
            .to({
                text: `${this._baseLoadingText}...`
            }, 1)
            .wait(loadingDotIntervalMs);
    }

    destroy() {
        super.destroy();

        createjs.Tween.removeTweens(this._target.loadingTextField);
    }
}